export const productMatch = (productA, productB) => {
    const equalSku = (productA === null || productA === void 0 ? void 0 : productA.sku) === (productB === null || productB === void 0 ? void 0 : productB.sku);
    const equalUid = (productA === null || productA === void 0 ? void 0 : productA.uid) === (productB === null || productB === void 0 ? void 0 : productB.uid);
    return equalSku && equalUid;
};
